import React from 'react';
import classNames from 'classnames';
import { SectionProps } from '../../utils/SectionProps';
import Image from '../elements/Image';

const propTypes = {
  ...SectionProps.types
}

const defaultProps = {
  ...SectionProps.defaults
}

const Hero = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  ...props
}) => {
  const outerClasses = classNames(
    'hero section',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'hero-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  return (
    <section
      {...props}
      className={outerClasses}
    >
      <div className="container section-inner">
        <div className="row">
          <div className={`${innerClasses} col-md-6`}>
            <div className="hero-content">
              <h1 className="mt-0 mb-16 reveal-from-bottom" data-reveal-delay="200">
                 <span className="text-color-primary">Halicon</span>
              </h1>
              <div>
                <p className="m-0 mb-32 reveal-from-bottom" data-reveal-delay="400">
                  Technology done right!
                </p>
                {/* <div className="reveal-from-bottom mt-4 m-text-center" data-reveal-delay="600">
                  <a href="/#services" className="button button-primary button-wide-mobile button-sm">Learn More</a>
                </div> */}
              </div>
            </div>
          </div>
          <div className="col-md-6">
          <Image
            src={require('./../../assets/images/logo.gif')}
            alt="Open"
            style={{ height: '460px', margin: 'auto'}} />
          </div>
        </div>
      </div>
    </section>
  );
}

Hero.propTypes = propTypes;
Hero.defaultProps = defaultProps;

export default Hero;